module.exports = __webpack_public_path__ + "img/last-zizhi.19ad4a90.png";